export enum UserRoles {
  SYSADMIN = 'sysadmin',
  HEAD_OF_PRACTICE = 'headOfPractice',
  PATIENT = 'patient',
  CLINICIAN = 'clinician',
}

export const HEADER_USER_ROLES: Record<string, string> = {
  sysadmin: 'System Administrator',
  headOfPractice: 'Head of Practice',
  patient: 'Patient',
  clinician: 'Clinician',
};
